import { Component, OnDestroy, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { GraphApi } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil, first } from 'rxjs/operators';

const enum FormStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PENDING = 'PENDING',
}
@Component({
  selector: 'app-user-search-ad',
  templateUrl: './user-search-ad.component.html',
  styleUrls: ['./user-search-ad.component.scss'],
})
export class UserSearchAdComponent implements OnInit, OnDestroy {
  @Input() invalidEmailMessage: string;

  @Output() selectedUserOutput = new EventEmitter<string>();
  @Output() formStatusOutput = new EventEmitter<string>();

  userDataForm: FormGroup;

  private searchOptions: { includeLdap: boolean };
  private onDestroy = new Subject<void>();

  constructor(private graphApi: GraphApi) {}

  ngOnInit() {
    this.userDataForm = new FormGroup({
      userSearchCtrl: new FormControl('', {
        validators: [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
        asyncValidators: this.validateExistingEmail.bind(this),
        updateOn: 'blur',
      }),
    });

    this.userDataForm.statusChanges.pipe(takeUntil(this.onDestroy)).subscribe((data) => {
      if (data === FormStatus.INVALID || data === FormStatus.PENDING) {
        this.formStatusOutput.emit('INVALID');
      } else if (data === FormStatus.VALID) {
        this.selectedUserOutput.emit(this.userDataForm.get('userSearchCtrl').value);
        this.formStatusOutput.emit('VALID');
      }
    });
  }

  validateExistingEmail(control: AbstractControl): Observable<null | { emailTaken: true }> {
    return this.graphApi.searchUsers(control.value, this.searchOptions).pipe(
      first(),
      map((data) => {
        const userNameExists = data.find(
          (res) => res.mail.toLowerCase() === control.value.toLowerCase()
        );

        if (!userNameExists) {
          return null;
        }
        return { emailTaken: true };
      })
    );
  }

  createForm() {
    this.userDataForm = new FormGroup({
      userSearchCtrl: new FormControl(''),
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
  }
}
